// =====================================================
// WeLearn Pro Player - Caption module
// =====================================================

export default class Caption {
    constructor(player) {
        this.player = player
    }

    /**
     * Add caption to video (Must be load before the player finished initialize)
     * @param label - Language name
     * @param srclang - Language abbreviation
     * @param src - Caption file path
     * @param setDefault - Set to true if this language is default language or vice versa
     */
    addCaption(label, srclang, src, setDefault = false) {
        $(this.player.element).append('' +
            `<track label="${label}" kind="captions" srclang="${srclang}" src="${src}" ${setDefault ? "default" : ""}>`)
    }
}
